var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"max-width":"400px"},attrs:{"value":_vm.valorAtual},on:{"change":function($event){return _vm.$emit('save', $event)}}},_vm._l((_vm.opcoes),function(op){return _c('el-option',{key:op.v,attrs:{"label":op.l,"value":op.v}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }